import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createLifeCycleApi(params: any) {
  let apiData: any = {
    programExternalId: params.programmeId.length ? params.programmeId : null,
    counterpartyExternalId: params.customerId.length ? params.customerId : null,
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/life-cycle`;
  return api.create(`${backendApiUrl}`, apiData);
}
export { createLifeCycleApi };
